/* Mixpanel Event Names */
export const MP_EVENT_PAGE_VIEWED = 'Page Viewed';

/* Registration Specific MP Constants. Used by Consumer, Pediatric, and B2b Reg */
export const LOGIN_EMAIL_EXISTS_ERROR = 'Email Already Exists';
export const WORK_LOGIN_EMAIL_ERROR = 'Work Email Used For Account';
export const LOGIN_EMAIL_FORM_FIELD = 'Login Email';
export const MODULE_ACCOUNT_CREATION_PAGE = 'Account Creation Page';
export const MODULE_ADDRESS_PAGE = 'Address Page';
export const MODULE_AMAZON_PAID_SIGNUP_PAGE = 'Welcome Amazon Sign Up Page';
export const MODULE_BILLING = 'Billing Page';
export const MODULE_CONTINUE_CARE_SCREEN = 'Continue Care Screen';
export const MODULE_FAMILY_TYPE_PAGE = 'Family Type Page';
export const MODULE_GCN_PROVIDER_MESSAGE_INTERSTITIAL = 'GCN Provider Message Interstitial Page';
export const MODULE_GCN_VIDEO_CHAT_COMPLETE_INTERSTITIAL = 'GCN Video Chat Complete Interstitial';
export const MODULE_LIMITED_ACCESS_INTERSTITIAL = 'Limited Access Interstitial';
export const MODULE_PEDIATRIC_TERMS_OF_SERVICE = 'Peds Terms of Service page';
export const MODULE_PHONE_DOB_SEX_PAGE = 'Phone DOB Sex Page';
export const MODULE_REGISTRATION_CONFIRMATION_PAGE = 'Registration Confirmation Page';
export const MODULE_REGISTRATION_ERROR_PAGE = 'Registration Error Page';
export const MODULE_REGISTRATION_POSTPONEMENT_PAGE = 'Registration Postponement Page';
export const MODULE_SIGNUP_PAGE = 'Sign Up Method Page';
export const MODULE_WELCOME_BACK_REGISTRATION_PAGE = 'Welcome Back Registration Page';

export const MFA_REGISTRATION_CONFIRMED = 'MFA Registration Confirmed';
export const MFA_REGISTRATION_ERROR_PAGE = 'MFA Registration Error Page';
export const MFA_REGISTRATION_PAGE = 'MFA Registration Page';
export const MP_EVENT_AMAZON_PAYMENT_BANNER_CLICKED = 'Banner Clicked';
export const MP_EVENT_BROWSE_PROVIDERS_CLICKED = 'Browse Providers Clicked';
export const MP_EVENT_CAPACITY_MODAL_CLOSED = 'Reaching Capacity Modal Closed';
export const MP_EVENT_CAPACITY_MODAL_VIEWED = 'Reaching Capacity Modal Viewed';
export const MP_EVENT_CONSUMER_REGISTRATION_PAYMENT_PAGE_VIEWED = 'Consumer Registration Payment Page Viewed';
export const MP_EVENT_CONTINUE_CARE_B2B = 'Continue Care Screen Sponsored Benefit Tapped';
export const MP_EVENT_CONTINUE_CARE_PAGE_VIEWED = 'Continue Care Screen Viewed';
export const MP_EVENT_CONTINUE_CARE_PURCHASE_WITH_AZ = 'Continue Care Screen Purchase With Amazon Tapped';
export const MP_EVENT_CONTINUE_CARE_PURCHASE_WITH_CC = 'Continue Care Screen Consumer Membership Tapped';
export const MP_EVENT_DOUBLE_OPT_IN_CLICKED = 'Double Opt In Clicked';
export const MP_EVENT_FAMILY_SUCCESSFULLY_SUBMITTED = 'Consumer Family Registration Successfully Submitted';
export const MP_EVENT_FEATURE_FLAG_EVALUATED = 'Feature Flag Evaluated';
export const MP_EVENT_FREE_TRIAL_REG_SUCCESSFULLY_SUBMITTED = 'Free Trial Consumer Registration Successfully Submitted';
export const MP_EVENT_GIFT_REG_SUCCESSFULLY_SUBMITTED = 'Consumer Gift Registration Successfully Submitted';
export const MP_EVENT_INVALID_CC_ENTERED = 'Invalid Credit Card Information Added';
export const MP_EVENT_LA_INTERSTITIAL_CALL_LINK_CLICKED = 'Limited Access Interstitial Call Office Link Tapped';
export const MP_EVENT_LA_INTERSTITIAL_MESSAGES_CLICKED = 'Limited Access Interstitial Messages Link Tapped';
export const MP_EVENT_LA_INTERSTITIAL_PAGE_VIEWED = 'Limited Access Interstitial Screen Viewed';
export const MP_EVENT_LIMITED_ACCESS_REG_SUCCESSFULLY_SUBMITTED = 'Limited Access Registration Successfully Submitted';
export const MP_EVENT_LOGIN_CLICKED = 'Login Clicked';
export const MP_EVENT_PROMO_CODE_AUTO_APPLIED = 'Promotion Code Auto Applied';
export const MP_EVENT_REF_REG_SUCCESSFULLY_SUBMITTED = 'Consumer Referral Registration Successfully Submitted';
export const MP_EVENT_REG_ACCORDION_FAQ_ANSWER_LINK_CLICKED = 'FAQ Answer Link Clicked';
export const MP_EVENT_REG_ACCORDION_FAQ_COLLAPSED = 'FAQ Question Collapsed';
export const MP_EVENT_REG_ACCORDION_FAQ_EXPANDED = 'FAQ Question Expanded';
export const MP_EVENT_REG_ACCORDION_FAQ_READ_LESS_CLICKED = 'FAQ Read Less Clicked';
export const MP_EVENT_REG_ACCORDION_FAQ_READ_MORE_CLICKED = 'FAQ Read More Clicked';
export const MP_EVENT_REG_ADD_DISCOUNT_CODE_CLICKED = 'Add Discount Code Clicked';
export const MP_EVENT_REG_CONFIRMATION_APPOINTMENT_CLICKED = 'Book Appointment Clicked';
export const MP_EVENT_REG_DISCOUNT_CODE_APPLIED = 'Discount Code Applied';
export const MP_EVENT_REG_INPUT_ERROR_OCCURRED = 'Input Error Encountered';
export const MP_EVENT_REG_INPUT_SUBMITTED = 'Registration Input Submitted';
export const MP_EVENT_REG_POSTPONEMENT_LEARN_MORE_CLICKED = 'Learn More Clicked';
export const MP_EVENT_REG_REDIRECT_TO_PEDIATRIC_REG_LINK_SELECTED = 'Register Child Link Selected';
export const MP_EVENT_REG_REDIRECT_TO_PEDIATRIC_REG_MODAL = 'Child Registration Modal Viewed';
export const MP_EVENT_REG_REDIRECT_TO_PEDIATRIC_REG_MODAL_DISMISSED = 'Child Registration Modal Dismissed';
export const MP_EVENT_REG_SUCCESSFULLY_SUBMITTED = 'Consumer Registration Successfully Submitted';
export const MP_EVENT_VIRTUAL_OFFERING_MODAL_CLOSED = 'Virtual Services Modal Closed';
export const MP_EVENT_VIRTUAL_OFFERING_MODAL_VIEWED = 'Virtual Services Modal Viewed';
export const MP_EVENT_WELCOME_BACK_COMPLETE_REGISTRATION_SUBMITTED = 'Welcome Back Complete Registration Submitted';
export const MP_FLOW_EXPIRED_MEMBERSHIP_CONVERSION = 'Expired membership conversion';
export const MP_FLOW_REGISTRATION = 'Registration';
export const SUBMODULE_CAPACITY_MODAL = 'Reaching Capacity Modal';
export const SUBMODULE_CHILD_REGISTRATION_MODAL = 'Child Registration Modal';
export const SUBMODULE_VIRTUAL_OFFERING_MODAL = 'Virtual Services Modal';

/* Enterprise Registration */
export const MODULE_DIRECT_SIGN_UP_SELECTION_PAGE = 'Direct Sign Up Selection Page';
export const MODULE_DIRECT_SIGN_UP_FAMILY_PAGE = 'Direct Sign Up Family Page';
export const MODULE_EMAIL_VERIFICATION_PAGE = 'Email Verification Page';
export const MODULE_ENTERPRISE_REGISTRATION_CONFIRMATION_PAGE = 'Enterprise Registration Confirmation Page';
export const MODULE_CONCIERGE_PAGE = 'Concierge Page';
export const MODULE_ACCOUNT_SETUP_PAGE = 'Account Setup Page';
export const MODULE_VERIFIED_ACCOUNT_SETUP_PAGE = 'Pre-Filled Account Setup Page';
export const MODULE_COMPANY_CODE_PAGE = 'Company Code Page';
export const MODULE_SCHEDULE_VISIT_PAGE = 'Schedule Visit Page';
export const MODULE_DOB_SEX_PAGE = 'DOB Sex Page';
export const MODULE_EID_VALIDATION_PAGE = 'EID Validation Page';
export const MODULE_CHOOSE_RELATIONSHIP_TYPE_PAGE = 'Choose Relationship Type Page';
export const MODULE_SERVICE_AREA_PAGE = 'Service Area Page';
export const MODULE_LEGAL_DOCUMENT_PAGE = 'Legal Document Page';
export const MODULE_WORK_EMAIL_VALIDATION_PAGE = 'Work Email Validation Page';
export const MODULE_PERSONAL_DETAILS_PAGE = 'Personal Details Page';
export const MODULE_CHILD_MEMBERSHIP_CONFIRMATION_PAGE = 'Child Membership Confirmation Page';
export const MODULE_APPOINTMENT_CONFIRMATION_PAGE = 'Appointment Confirmation Page';
export const MODULE_VERIFIED_EXISTING_USER_PAGE = 'HRIS Existing Member Redirect Page';
export const PAGE_APPOINTMENT_INVENTORY = 'Appointment Inventory Page';
export const MODULE_VERIFIED_ENTERPRISE_REGISTRATION_LOADING_PAGE = 'HRIS New Member Redirect Page';
export const MODULE_VERIFIED_EXPIRED_TOKEN_PAGE = 'HRIS Session Expired';

/* Expedited Registration */
export const MODULE_EXPEDITED_ACCOUNT_CREATION_PAGE = 'Welcome Amazon Prefill Sign Up Page';
export const MODULE_EXPEDITED_ACCOUNT_CREATION_VALIDATION_ERROR_PAGE = 'Welcome Amazon Prefill Validation Error';
export const MP_EVENT_EXPEDITED_ERROR_MANUAL_SIGN_UP = 'Amazon Prefill Sign Up Manually Submitted';
export const MODULE_EXPEDITED_ACCOUNT_CREATION_EXISTING_EMAIL_ERROR = 'Welcome Amazon Prefill Existing Email Error';
export const MP_EVENT_LOGIN_WITH_EXISTING_ACCOUNT = 'Login With Existing Account Submitted';
export const EXPEDITED_REGISTRATION_MP_FLOW_VERSION = 'shelduck_registration_2023';
export const MODULE_EXPEDITED_ACCOUNT_CREATION_PREFILL_ERROR = 'Welcome Amazon Prefill Sign Up Page Error';
export const MP_EVENT_PREFILL_RETRY = 'Amazon Prefill Sign Up Manually Retry';
export const MP_EVENT_SLLT_MISSING_ERROR = 'Amazon SLLT Missing Error';

/* Password Reset */
export const EXPIRED_RESET_PASSWORD_CLICKED = 'Expired Reset Password Link Clicked';

/* Action Items/Patient Tasks */
export const MODULE_ALL_TASKS_PAGE = 'All Tasks Page';

/* Enterprise Post-Registration Appointment Recommendation Experiment */
export const ISSUE_REFINEMENT_PAGE = 'Issue Refinement Page';
export const ISSUE_SELECTION_PAGE = 'Issue Selection Page';

/* Membership Settings */
export const MODULE_SETTINGS_PAGE = 'MyOne Membership Settings Page';
export const ACCOUNT_SECURITY_PAGE = 'Account Security Page';

/* Membership Upgrade */
export const MODULE_MEMBERSHIP_UPGRADE_PAGE = 'Membership Upgrade Page';

/* Prepaid Enrollment Registration */
export const MODULE_PREPAID_REGISTRATION_LANDING_PAGE = 'Welcome Prepaid Sign Up Page';
export const PREPAID_REGISTER_MP_FLOW_VERSION = 'hornbill_registration_2023';

/* Prepaid Enrollment Conversion */
export const MP_EVENT_PREPAID_AMAZON_CONVERSION = 'Consumer Prepaid Amazon Successfully Applied';
export const MP_EVENT_PREPAID_AMAZON_OPT_OUT = 'Consumer Prepaid Amazon Opt Out';
export const MODULE_PREPAID_CONVERSION_PAGE = 'Update Account To Prepaid Amazon Page';

/* Prepaid Enrollment Membership Management */
export const FLOW_PREPAID_MEMBER_MANAGEMENT = 'Member Management';
export const MODULE_PREPAID_EMAIL_INVITE_PAGE = 'Member Email Invitation Page';
export const MP_EVENT_PREPAID_INVITE_SENT = 'Family or Friend Invite Sent';
export const MP_EVENT_PREPAID_INVITE_ADD_MEMBER_CLICKED = 'Add Member Clicked';
export const MODULE_PREPAID_INVITE_HOUSEHOLD_LIST_PAGE = 'Household Invite List Page';
export const MODULE_PREPAID_INVITE_FAMILY_TYPE_PAGE = 'Invite Family Type Page';
export const MP_EVENT_PREPAID_INVITE_FRIEND_FAMILY_TYPE_SELECTED = 'Family or Friend Type Selected';
export const RESEND_INVITATION_MODAL = 'Resend Invitation Modal';
export const CANCEL_INVITATION_MODAL = 'Cancel Invitation Modal';

/* Email Verification */
export const MP_EVENT_EMAIL_VERIFIED = 'Email Successfully Verified';
export const MP_EVENT_EMAIL_UNVERIFIED = 'Email Unsuccessfully Verified';
export const MP_EVENT_EMAIL_VERIFICATION_ACTION = 'Email Verification Action Selected';
export const MP_EVENT_EMAIL_VERIFICATION_ACCOUNT_LOCKED = 'Account Locked';
export const MP_EVENT_EMAIL_VERIFICATION_SENT = 'Verification Email Sent';
export const MP_EVENT_EDIT_EMAIL = 'Edit Email Clicked';
export const MP_EVENT_EDIT_EMAIL_ACTION = 'Edit Email Action Selected';
export const MP_EVENT_ADD_PREFERRED_EMAIL = 'Add Preferred Email Clicked';
export const MP_EVENT_ADD_PREFERRED_EMAIL_ACTION = 'Add Preferred Email Action Selected';
export const MP_EVENT_UPGRADE_FROM_EMAIL_CLICKED = 'Upgrade with One Medical from email Clicked';
export const MP_EVENT_UPGRADE_WITH_OM_PHONE_NUMBER_CLICKED = 'Upgrade with One Medical Phone Number Clicked';
export const SUBMODULE_CODE_MODAL = 'Email Verification Modal';
export const SUBMODULE_EMAIL_NOTIFICATION = 'Email Notification Modal';

export enum MP_EVENT_EMAIL_VERIFICATION_ACTION_TYPE {
  CONTINUE = 'Continue',
  EMAIL = 'techsupport@onemedical.com',
  SKIP = 'Skip for now',
  RESEND = 'Resend email',
}

export const MODULE_HOME_PAGE = 'MyOne Home Page';
export const SUBMODULE_EMAIL_VERIFICATION_CAROUSEL_CARD = 'Email Verification Onboarding Carousel Card';
export const EMAIL_VERIFICATION_OUTREACH_EMAIL = 'Email Verification Outreach Email';

/* Legacy Provider Team Page aka PCP Overview Page */
export const MODULE_PCP_OVERVIEW_PAGE = 'PCP Overview Page';

/* Messages */
export const MODULE_MESSAGES_OVERVIEW_PAGE = 'Messages Overview Page';
export const MESSAGES_CLICKED = 'Messages Clicked';
export const FLOW_MESSAGES = 'Messages';
export const SUBMODULE_CARE_TEAM_MESSAGES_BUTTON = 'Care Team Messages Button';
export const TIMELINE_POST_CREATED = 'Timeline Post Created';

/* Flows */
export const FLOW_ACCOUNT_UPDATE = 'Account Update';
export const FLOW_HOME_PAGE_NAVIGATION = 'Home Page Navigation';
export const FLOW_LOGIN = 'Login';
export const FLOW_LOGOUT = 'Logout';
export const FLOW_POST_REGISTRATION = 'Post Registration';
export const FLOW_ONBOARDING = 'Onboarding';
export const FLOW_APPOINTMENT_BOOKING = 'Appointment Booking';
export const FLOW_APPOINTMENT_RESCHEDULE = 'Reschedule Visit';
export const FLOW_PATIENT_TASKS = 'Patient Tasks';
export const FLOW_HELP_CENTER = 'Help Center';
export const FLOW_GET_CARE = 'Get Care';
export const TOPIC_REMOTE_VISIT = 'Remote Visit';
export const FLOW_ACCOUNT_CLAIMING = 'Account Claiming';
export const FLOW_VERSION_GCN_POST_VISIT = 'GCN Post Visit';
export const FLOW_VERSION_TOPICS_INGRESS = 'topics_ingress';
export const FLOW_ONE_MEDICAL_AI = 'One Medical AI';
export const FLOW_SCRIBE = 'Scribe';

/* Modals */
export const PRESCRIPTION_TREAT_ME_NOW_MODAL = 'Prescription TMN';
export const EVENT_TREAT_ME_NOW_MODAL_CLOSED = 'TMN Modal Closed';
export const REFERRAL_MODAL = 'MyOne Friends and Family Referral Modal';
export const PROVIDER_MODAL = 'Provider Bio Modal';

/* Login */
export const LOGIN_STARTED = 'Login Started';

/* MFA */
export const MP_EVENT_MFA_STATUS_CHANGE = 'Two Factor Authentication Updated';
export const MP_EVENT_MFA_RECOVERY_CODE_REGENERATION = 'Regenerate Recovery Code Clicked';
export const MP_EVENT_MFA_RECOVERY_CODE_COPIED = 'Copy Recovery Code Clicked';
export const MP_USER_PROFILE_MFA_PROPERTY_NAME = 'Twofactor Authentication Enabled';
export const MP_EVENT_MFA_ENABLE_CLICKED = 'Enable Multi-factor Authentication Clicked';
export const MP_EVENT_MFA_UPDATE_NUMBER_CLICKED = 'Update Multi-factor Authentication Clicked';
export const MP_EVENT_MFA_UPDATE_NUMBER_CONFIRMED = 'Update Multi-factor Authentication Confirmed';

/* Home */
export const EVENT_BANNER_CLICKED = 'Banner Clicked';
export const SUBMODULE_COVID_RESOURCES = 'Covid Resources';
export const MOBILE_ENGAGEMENT = 'Mobile Engagement';
export const EVENT_BOOK_VISIT_CLICKED = 'Book Visit Clicked';
export const EVENT_SCHEDULE_VISIT_CLICKED = 'Schedule Visit Clicked';
export const EXPLORE_OTHER_APPOINTMENTS_CLICKED = 'Explore Other Appointments Clicked';
export const EVENT_RECOMMENDED_SERVICES_CARD_CLICKED = 'Recommended Services Card Clicked';
export const JOIN_REMOTE_VISIT_CLICKED = 'Join Remote Visit Clicked';
export const APPOINTMENT_DIRECTIONS_CLICKED = 'Appointment Directions Clicked';
export const VIEW_APPOINTMENT_DETAILS_CLICKED = 'View Appointment Details Clicked';
export const RUNNING_LATE_APPOINTMENT_CLICKED = 'Running Late Appointment Clicked';
export const APPOINTMENT_MARKED_AS_RUNNING_LATE = 'Appointment Marked As Running Late';
export const BOTTOM_GROWTH_BANNER = 'Bottom Growth Banner';
export const MYONE_HEADER_BANNER = 'MyOne Header Banner';
export const HEADER_BANNER = 'Header Banner';
export const REMINDER_CLICKED = 'Reminder Clicked';
export const TRAVEL_RECOMMENDATIONS_CLICKED = 'Travel Recommendations Clicked';
export const FSA_REIMBURSEMENT_CLICKED = 'FSA Reimbursement Clicked';
export const DOWNLOAD_APP_CLICKED = 'Download App Clicked';
export const MODULE_DOWNLOAD_MOBILE_APP = 'Download Mobile App for On Demand Care';
export const SUBMODULE_BOOK_VISIT_BUTTON = 'Book Visit Button';
export const SUBMODULE_DOWNLOAD_APP_HERO_BANNER = 'Download App Hero Banner';
export const BOTTOM_BANNER_CLICKED = 'Bottom Banner Clicked';
export const EXPERIMENT_VARIATION_ASSIGNED = 'Experiment Variation Assigned';
export const TREAT_ME_NOW_CLICKED = 'Treat Me Now Clicked';
export const MODAL_VIEWED = 'Modal Viewed';
export const MODAL_CLOSED = 'Modal Closed';
export const MODULE_REMOTE_VISIT_MODAL = 'Remote Visit Modal';
export const PREFERRED_PHARMACY_CLICKED = 'Choose Preferred Pharmacy Clicked';
export const SUBMODULE_GET_ON_DEMAND_CARE = 'Get On-Demand Care';
export const VIDEO_CHAT_FOR_COMMON_CONDITIONS = 'Video Chat for Common Conditions';
export const SUBMODULE_VIDEO_CHAT_FOR_COMMON_CONDITIONS = 'Topics';
export const CHOOSE_FROM_TOP_CONCERNS = 'Choose from Top Concerns';
export const SUBMODULE_CHOOSE_FROM_TOP_CONCERNS = 'Topics Ingress';
export const MODULE_TOPIC_DETAILS_PAGE = 'Topic Details Page';
export const TOPIC_CARE_OPTION_SELECTED = 'Care Option Selected';

/* AI */
export const AI_CHAT_ABOUT_PAGE = 'About One Medical AI Page';
export const SCRIBE_ABOUT_PAGE = 'About Scribe Page';

/* Tab */
export const CARD_ACTION_SELECTED = 'Card Selected';
export const TAB_ACTION_SELECTED = 'Tab Selected';
export const TAB_SECTION_INPUT_SUBMITTED = 'Tab Section Input Submitted';

/* Navbar */
export const NAVIGATION_BAR = 'Navigation Bar';

/* Health Record */
export const MODULE_LAB_RESULT_DETAILS_PAGE = 'Lab Result Details Page';

/* My Provider PCP Selection & Experiment */
export const EVENT_PCP_SELECTED = 'PCP Selected';
export const EVENT_PROVIDER_HUB_APPT_CARD_CLICKED = 'Appointment Type Card Clicked';
export const EVENT_PROVIDER_HUB_ALL_SET_CLICKED = "I'm All Set For Now Clicked";
export const EVENT_VIEW_MORE_PROVIDERS_CLICKED = 'View More Providers Clicked';
export const MODULE_PCP_OVERVIEW = 'PCP Overview Page';
export const MODULE_PCP_SELECTION_PAGE = 'PCP Selection Page';
export const MODULE_PCP_SELECTED_MODAL_PAGE = 'PCP Selected Modal Page';
export const MODULE_PCP_CARE_OPTIONS_PAGE = 'PCP Care Options Page';
export const FLOW_PCP_SELECTION = 'PCP Selection';
export const SOURCE_PCP_OVERVIEW_PAGE = 'PCP Overview Page';
export const MANAGE_PRESCRIPTIONS_CLICKED = 'Manage Prescriptions Clicked';
export const PRESCRIPTION_MANAGEMENT = 'Prescription Management';
export const MODULE_PRESCRIPTION_RENEWAL_PAGE = 'Prescription Renewal Page';
export const URGENT_VIDEO_CHAT_CLICKED = 'Urgent Video Chat Clicked';
export const SEND_DOWNLOAD_LINK_CLICKED = 'Send Download Link Clicked';
export const SKIP_DOWNLOAD_LINK_CLICKED = 'Skip Download Link Clicked';
export const MOBILE_ENGAGEMENT_MODAL_CLOSED = 'Mobile Engagement Modal Closed';
export const MODULE_HELP_CENTER = 'Help Center Page';

/* Appointments */
export const SUBMODULE_LOCATION_SELECTION = 'Location Selection Page';
export const APPOINTMENT_CANCEL_CLICKED = 'Cancel Appointment Clicked';
export const APPOINTMENT_CANCELLED = 'Appointment Cancelled';
export const MODULE_SWITCH_CANCEL_TO_REMOTE_PAGE = 'Switch Cancel to Remote Page';
export const MODULE_SWITCH_RESCHEDULE_TO_REMOTE_PAGE = 'Switch Reschedule to Remote Page';
export const SWITCH_TO_REMOTE_VISIT_CLICKED = 'Attend Over Video Clicked';
export const APPOINTMENT_RESCHEDULE_CLICKED = 'Reschedule Appointment Clicked';
export const MP_EVENT_ADD_TO_CALENDAR_CLICKED = 'Add to Calendar Clicked';
export const MP_EVENT_BANNER_ADD_TO_CALENDAR_CLICKED = 'Banner Add to Calendar Clicked';
export const MP_EVENT_SELF_PAY_CLICKED = 'Self Pay Clicked';
export const MP_EVENT_SELF_PAY_ESTIMATE_DISPLAYED = 'Self Pay Estimate Displayed';
export const MP_EVENT_ADD_INSURANCE_SUBMITTED = 'Add Insurance Submitted';
export const MP_EVENT_INSURANCE_CARRIER_SELECTED = 'Insurance Carrier Selected From Dropdown';
export const MP_EVENT_ADD_OR_REPLACE_INSURANCE_CLICKED = 'Add/Replace Insurance Clicked';
export const MP_EVENT_APPOINTMENT_SELECTED = 'Appointment Selected';
export const MP_EVENT_MODAL_DISMISSED = 'Modal Dismissed';
export const MP_EVENT_MODAL_DISPLAYED = 'Modal Displayed';
export const MP_EVENT_REVIEW_BOOKING_CLICKED = 'Review and confirm booking clicked';
export const MP_EVENT_ADD_INSURANCE_TIMED_OUT = 'Add Insurance Timed Out';
export const MP_EVENT_CONTINUE_CLICKED = 'Continue Clicked';
export const MP_EVENT_BACK_CLICKED = 'Back Button Clicked';
export const MP_EVENT_HAVE_INSURANCE_CLICKED = 'Have Insurance Clicked';
export const MP_EVENT_SELF_PAY_CONFIRMED = 'Confirmed Self Pay';
export const MP_EVENT_CONTINUE_TO_ADD_INSURANCE_PAGE = 'Continue to Add Insurance Page';
export const MP_EVENT_SAVE_PAYMENT_CLICKED = 'Save Payment Clicked';
export const MP_EVENT_ACTION_DEFERRED = 'Action Deferred';
export const MP_EVENT_PAYMENT_METHOD_ADDED = 'Payment Method Added';
export const MP_EVENT_PAYMENT_METHOD_NICKNAME_UPDATED = 'Payment Method Nickname Updated';
export const MP_EVENT_PAYMENT_METHOD_SET_AS_DEFAULT = 'Payment Method Set As Default';
export const MP_EVENT_PAYMENT_METHOD_SET_AS_PREFERRED = 'Payment Method Set As Preferred';
export const MP_EVENT_PAYMENT_METHOD_DELETED = 'Payment Method Deleted';
export const MP_EVENT_ADD_COPAY_PAYMENT_METHOD_CLICKED = 'Add Copay Payment Method Clicked';
export const MP_EVENT_ADD_OR_REPLACE_PAYMENT_METHOD_CLICKED = 'Add/Replace Payment Method Clicked';
export const MP_EVENT_ADD_BUTTON_CLICKED = 'Add Button Clicked';
export const MP_EVENT_UPDATE_BUTTON_CLICKED = 'Update Button Clicked';
export const MP_EVENT_CONFIRM_BUTTON_CLICKED = 'Confirm Button Clicked';
export const MP_EVENT_DELETE_BUTTON_CLICKED = 'Delete Button Clicked';
export const MP_EVENT_CANCEL_BUTTON_CLICKED = 'Cancel Button Clicked';
export const MP_EVENT_KEEP_BUTTON_CLICKED = 'Keep Button Clicked';
export const AMAZON_BOOKING = 'Amazon Booking';

/* Scribe Consent */
export const MP_EVENT_SCRIBE_CONSENT_UPDATED = 'Scribe Consent Updated';
export const MP_MODULE_SCRIBE_CONSENT_PROMPT = 'Consent Prompt';
export const MP_SUBMODULE_SCRIBE_CONSENT_TOGGLE = 'Scribe Consent Toggle';
export const MP_SUBMODULE_SCRIBE_CONSENT_BUTTON = 'Scribe Consent Button';

/* Membership Cancellation/reactivation */
export const MEMBERSHIP_CANCELLATION_PAGE = 'Membership Cancellation Page';
export const MEMBERSHIP_CANCELLATION_REASONS_PAGE = 'Membership Cancellation Reason Page';
export const MEMBERSHIP_CANCELED = 'Membership Canceled';
export const MEMBERSHIP_CANCELLATION_NO_SURVEY = 'Cancellation Survey Removed Version';
export const MEMBERSHIP_CANCELLATION_REASON_SKIPPED = 'Membership Cancellation Reason Skipped';
export const MEMBERSHIP_CANCELLATION_REASON_SUBMITTED = 'Membership Cancellation Reason Submitted';
export const MEMBERSHIP_REACTIVATED = 'Membership Reactivated';
export const REACTIVATE_MEMBERSHIP_CLICKED = 'Reactivate Membership Clicked';

/* Mental Health Topic Routing */
export const MODULE_MENTAL_HEALTH_TOPIC_ROUTING_PAGE = 'Mental Health Topic Routing Page';

/* Family Account Management & Account Switching */
export const FLOW_FAMILY_ACCOUNT_MANAGEMENT = 'Family Account Management';
export const MP_EVENT_SWITCH_ACCOUNT_CLICKED = 'Switch Account Clicked';
export const MP_SWITCH_ACCOUNT_TO_PRINCIPAL = 'Parent Account';
export const MP_SWITCH_ACCOUNT_TO_TARGET = 'Child Account';
export const MODULE_HOUSEHOLD_ACCOUNT_PAGE = 'Household Account Page';
export const MODULE_CONNECT_ACCOUNT_MODAL = 'Connect Account Modal';
export const MODULE_FINISH_LINKING_ACCOUNT_MODAL = 'Finish Linking Account Modal';

/* Referrals */
export const MP_EVENT_FRIENDS_AND_FAMILY_REFERRAL_STARTED = 'Friends and Family Referral Started';

/* Amazon Pharmacy */

// IMPRESSION
export const MP_APEE_DATA_SHARE_REVIEW_ERROR_VIEWED = 'Data Sharing Error Viewed';

// CONVERSION
export const MP_APEE_GET_STARTED = 'Get Started Clicked';
export const MP_APEE_CONTINUE_TO_AP_CANCELLED = 'Continue to Amazon Pharmacy Cancelled';
export const MP_APEE_ENROLLMENT_CONFIRMED = 'Amazon Pharmacy Enrollment Confirmed';
export const MP_APEE_CONTINUE_TO_AP = 'Expedited Enrollment Option Clicked';
export const MP_APEE_SIGN_UP_DIRECTLY_ON_AMAZON = 'Non Expedited Enrollment Option Clicked';
export const MP_APEE_SIGN_IN_TO_AMAZON = 'Sign In To Amazon Pharmacy Clicked';
export const MP_APEE_EMAIL_OPTION = 'Email Clicked';
export const MP_APEE_DATA_SHARE_UPDATE = 'Update Information Clicked';
export const MP_APEE_SIGN_UP_LATER = 'Sign Up Later Clicked';
export const MP_APEE_STAY_IN_ONE_MEDICAL = 'Stay in One Medical Clicked';

/* Preferred Pharmacy */
export const PREFERRED_PHARMACY = 'Preferred Pharmacy';
export const MODULE_PREFERRED_PHARMACY_PAGE = 'Preferred Pharmacy Page';
export const MODULE_SELECT_A_PHARMACY_PAGE = 'Select a Pharmacy Page';
export const MODULE_PENDING_PRESCRIPTION_RENEWAL_PAGE = 'Pending Prescription Renewal Page';
export const PHARMACY_LISTING_CLICKED = 'Pharmacy Listing Clicked';
export const PRESCRIPTION_RENEWAL_SUBMITTED = 'Prescription Renewal Submitted';

/* Login With Amazon */
export const MP_EVENT_SET_UP_LWA_CLICKED = 'Set Up Login with Amazon Clicked';
export const SWITCH_TO_LWA_MP_FLOW_VERSION = 'Switch to Login with Amazon';
export const VERIFY_YOUR_PASSWORD = 'Verify Your Password';
export const MP_EVENT_VERIFY_PASSWORD_ERROR = 'Verify Password Error';
export const LOGIN_AND_SECURITY_PAGE = 'Login & Security Page';
export const ACCOUNT_SETTINGS_PAGE = 'Account Settings Page';
export const AUTH0_LOGIN_PAGE = 'Auth0 Login Page';
export const MP_LWA_DATA_SHARE_REVIEW_PAGE = 'Login with Amazon Data Share Review Page';
export const MP_LWA_SHARE_AND_CONTINUE_CLICKED = 'Share and Continue Clicked';
export const MP_LWA_EMAIL_CLICKED = 'Email Clicked';
export const MP_LWA_DATA_SHARING_ERROR_VIEWED = 'Data Sharing Error Viewed';
export const MP_LWA_LINKING_CONFIRMATION_PAGE = 'Login with Amazon Account Linked';
export const LOGIN_WITH_AMAZON_MP_FLOW_VERSION = 'login_with_amazon';
export const LIMITED_ACCESS_FLOW_VERSION = 'limited_access';
export const DEMOGRAPHICS_PAGE_SOURCE = 'Amazon Demographic Info Page';
export const VISIT_AMAZON_CLICKED = 'Visit Amazon Clicked';
export const SIGN_UP_MANUALLY_SUBMITTED = 'Amazon Prefill Sign Up Manually Submitted';
export const LOG_IN_WITH_EXISTING_ACCOUNT_SUBMITTED = 'Login With Existing Account Submitted';
export const SIGN_UP_TAPPED = 'Sign Up Tapped';

/* Kestrel */
export const KESTREL_MP_FLOW_VERSION = 'kestrel_2024';
export const KESTREL_MP_LANDING_PAGE = 'Limited Access Enrollment Landing Page';
export const LOGIN_WITH_AMAZON_PAGE_SOURCE = 'Login With Amazon';
export const SERVICE_AREA_PAGE_SOURCE = 'Service Area Page';

/* Account Claiming */
export const MP_ACCOUNT_CLAIMING_FLOW_VERSION = 'senior_business_registration_2025';
export const MP_ACCOUNT_CLAIMING_VERIFICATION_PAGE = 'Name DOB Page';
export const MP_SENIOR_HEALTH_PLAN_TYPE = 'Senior Health Plan';
export const MP_MODULE_RESTART_ACCOUNT_CREATION_PAGE = 'Restart Account Creation Page';

/* Health Information Exchange */
export const MP_EVENT_HIE_CONSENT_OPTED_IN = 'HIE Consent Opted In';
export const MP_EVENT_HIE_CONSENT_OPTED_OUT = 'HIE Consent Opted Out';
